import { Component, OnInit, ViewChild } from '@angular/core';
import { tap } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from "@angular/router";
import { UserService, UserSummary } from '../user.Service';
import {MatTableDataSource} from '@angular/material/table';
import { Observable } from "rxjs";
import { ChangeUsernameComponent } from '../user-details/change-username/change-username.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService, Organization } from '../authentication.Service';
import { SurveyService } from '../survey.Service';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { JsonCyclic } from '../utils';
import { ImportUsersComponent } from './import-users/import-users.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  sb: MatSnackBarRef<any> | undefined;
  tempUsers: Observable<any>;
  userId: number = - 1;
  Users: UserSummary[] = [];
  organizations: Organization[] = [];
  dataSource: any;
  orgDataSource = new MatTableDataSource(this.organizations);
  userDataSource = new MatTableDataSource(this.Users);
  displayedColumns: string[] = [];
  displayedUserColumns: string[] = ['UserID', 'BusinessType', 'Tfa', 'CreateDate', 'LastLoggedIn', 'UserName', 'FirstName', 'LastName', 'EmailAddress'];
  displayedOrgColumns: string[] = ['name', 'description', 'created', 'role', 'action'];
  user: UserSummary;
  contextSelected: boolean = false;
  dialogRef: MatDialogRef<any, any>;
  filter: number = 1;
  filterType: string = "Live Users";

  @ViewChild('contextMenuTrigger') contextMenu: MatMenuTrigger;

  constructor(public dialog: MatDialog,
    public translate: TranslateService,
    private snackbar: MatSnackBar,
    private userService: UserService,
    private surveyService: SurveyService,
    private authenticationService: AuthenticationService,
    private router: Router) {
    this.authenticationService.getUserId().subscribe(result => {
      this.userId = Number(result);
      this.getUsers(1);
    });
  }

  ngOnInit(): void {
  }

  import() {
    this.dialogRef = this.dialog.open(ImportUsersComponent, { height: '80%', width:'80%' });
  }

  export() {
    this.sb = this.snackbar.open("Exporting...", "");
    this.userService.exportUsers().subscribe(
      response => {
        this.downLoadFile(response, "text/plain", ".diy")
      },
      error => {
        this.sb?.dismiss();
      });
    return false;

  }

  downLoadFile(data: any, type: string, ext: string) {
    let blob = new Blob([JsonCyclic.toJson(data)], { type: "text/plain" });
    let url = window.URL.createObjectURL(blob);
    //Download by dynamically creating a tag
    const a = document.createElement('a');
    const fileName = "users";
    a.href = url;
    // a.download = fileName;
    a.download = fileName + ext;
    a.click();
    window.URL.revokeObjectURL(url);
    this.sb?.dismiss();
  }

  leave(org: Organization) {

  }

  owner(organization: Organization): string {
    let owner = organization.Owner.UserName;
    if (organization.Owner.UserName !== organization.Owner.EmailAddress) {
      owner += " (" + organization.Owner.EmailAddress + ")";
    }

    return owner;
  }

  role(organization: Organization): string {
    if (organization.OwnerId === this.userId) {
      return "Owner";
    }

    for (let i = 0; i < organization.Roles.length; i++) {
      if (organization.Roles[i].UserId == this.userId) {
        if (organization.Roles[i].RoleId == 19) {
          return "Guest";
        }

        return "Moderator";
      }
    }

    for (let i = 0; i < organization.Invitations?.length; i++) {
      if (organization.Invitations[i].UserId == this.userId) {
        return "Invited";
      }
    }

    return "Snubbed";
  }

  isOwner(organization: Organization): boolean {
    return organization.OwnerId === this.userId;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  businessType(user: UserSummary): string {
    if (UserService.hasRole(user.Roles, "Cash")) {
      return "shopping_cart";
    }

    return "credit_card";
  }

  isTemplate(user: UserSummary): boolean {
    return UserService.hasRole(user.Roles, "template") || UserService.hasRole(user.Roles, "Admin");
  }

  templateType(user: UserSummary): string {
    return UserService.hasRole(user.Roles, "Admin") ? "A" : "T";
  }

  contextMenuPosition = { x: '0px', y: '0px' };
  onContextMenu(event: MouseEvent, user: UserSummary) {
    event.preventDefault();
    this.contextSelected = true;
    this.user = user;
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'user': user };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
  }

  edit(user: UserSummary) {
    this.router.navigate(["/edituser", user.UserID, "user"]);
  }

  impersonate(user: UserSummary): boolean {
    if (UserService.hasRole(user.Roles, "Admin") || UserService.hasRole(user.Roles, "sa")) {
      event.preventDefault();
      this.authenticationService.impersonateAs(user.UserName)
        .subscribe(result => {
          this.authenticationService.setAccessToken(result.Token);
          this.authenticationService.storeSettings(result.Claims);
          this.surveyService.getSurveyCount()
            .subscribe(response => {
              if (response > 0) {
                this.router.navigate(['../surveydashboard']);
              } else {
                this.router.navigate(['../startfromtemplate']);
              }
            },
              error => {
                if (error === 401) {
                  this.router.navigate(['../']);
                }
              });
        },
          error => {
            console.error(error);
          });
    }

    return false;
  }

  get2FA(member: UserSummary): boolean {
    return member.TwoFA > 0;
  }

  filterBy(index: number) {
    this.filter = index;
    let ft = "Live Users";
    switch (index) {
      case 1:
        ft = "Live Users";
        break;
      case 2:
        ft = "Suspended Users";
        break;
      case 3:
        ft = "Unconfirmed Users";
        break;
      case 4:
        ft = "Deleted Users";
        break;
      case 5:
        ft = "Template Users";
        break;
      case 6:
        ft = "Admin Users";
        break;
      case 7:
        ft = "Organizations";
        break;
    }

    if (ft != this.filterType) {
      this.filterType = ft;
      this.getUsers(index);
    }
  }

  getUsers(index: number) {
    if (index == 7) {
      this.displayedColumns = this.displayedOrgColumns;
      this.tempUsers = this.authenticationService.getOrganizations().pipe(tap<Organization[]>(result => {
        this.organizations = result as Organization[];
        this.dataSource = new MatTableDataSource(this.organizations);
      }));
      return;
    }

    this.displayedColumns = this.displayedUserColumns;
    this.tempUsers = this.userService.getUsers(index).pipe(tap<UserSummary[]>(result => {
      this.Users = result;
      this.dataSource = new MatTableDataSource(this.Users);
    }));
  }

  signin(user: UserSummary) {
    if (UserService.hasRole(user.Roles, "Admin") || UserService.hasRole(user.Roles, "sa")) {
      event.preventDefault();
      this.authenticationService.loginAs(user.UserName)
        .subscribe(result => {
          this.authenticationService.setAccessToken(result.Token);
          this.authenticationService.storeSettings(result.Claims);
          this.surveyService.getSurveyCount()
            .subscribe(response => {
              if (response > 0) {
                this.router.navigate(['../surveydashboard']);
              } else {
                this.router.navigate(['../startfromtemplate']);
              }
            },
              error => {
                if (error === 401) {
                  this.router.navigate(['../']);
                }
              });
        },
          error => {
            console.error(error);
          });
    }

    return false;
  }

  createUser() {
    let dialogRef = this.dialog.open(ChangeUsernameComponent, {
      data: { id: 0 }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.userid) {
        this.router.navigate(["/edituser", result.userid, "user"]);
      }
    });
  }
}
